import { ToggleLeft } from 'lucide-react'
import { RestrictionScreen } from './RestrictionScreen'
import { GEO_STR as S } from './geoApi'

/**
 * A11.06 — Funksiya bo'yicha cheklov. REAL `/admin/countries` + greenfield
 * overlay (`/admin/geo/feature-restrictions` → `{code, features}`): davlat
 * bo'yicha o'chirilgan funksiyalar (qo'ng'iroq/bot/kanal).
 */
export function FeatureRestrictionsScreen() {
  return (
    <RestrictionScreen
      screenId="A11.06"
      title={S.featureTitle}
      note={S.featureNote}
      icon={<ToggleLeft size={28} strokeWidth={1.5} />}
      overlayPath="/admin/geo/feature-restrictions"
      overlayKey="restrictions"
      overlayField="features"
      overlayHeader={S.features}
    />
  )
}
